import { requestFromServer } from "./api-client";

const NewSchedulling = {
  add: async (editingItem) => {
    let files = [];

    if (editingItem.driverLicenseImg) {
      files = [...files, editingItem.driverLicenseImg.id];
    }

    if (editingItem.nfImg) {
      files = [...files, editingItem.nfImg.id];
    }

    if (editingItem.truckDocumentImg) {
      files = [...files, editingItem.truckDocumentImg.id];
    }

    const data = {
      client_document_number: editingItem.cliente,
      client_name: editingItem.nameClient,
      id_product: parseInt(editingItem.product),
      id_plant_dest: parseInt(editingItem.plant),
      id_load_type: editingItem.loadingType,
      id_scheduling_status: 1,
      id_time_block: parseInt(editingItem.turno),
      volume: parseInt(editingItem.volume),
      document_number: parseInt(editingItem.nf),
      serial_number: parseInt(editingItem.serialNumber),
      transporter_document: editingItem.transporterDocumentNumber,
      truck_plate: editingItem.driverPlate,
      driver_name: editingItem.driver,
      id_driver: editingItem.id_driver,
      driver_document: editingItem.driverLicense,
      scheduling_date: editingItem.date,
      files: files,
    };
    return requestFromServer(`v1/Schedulings/add`, "POST", data);
  },
};

export default NewSchedulling;
